import PageHeader from "@/components/PageHeader";
import WallFeed from "@/components/WallFeed";
import { useI18n } from "@/i18n/i18n";

export default function WallBoard() {
  const { t } = useI18n();
  return (
    <div data-testid="wall-board-page">
      <PageHeader title={t("wall_board")} testId="wall-board-header" />
      <WallFeed limit={100} />
    </div>
  );
}
